import { render, staticRenderFns } from "./SpaceDashboardContent.vue?vue&type=template&id=6f778d6e&scoped=true&"
import script from "./SpaceDashboardContent.vue?vue&type=script&lang=js&"
export * from "./SpaceDashboardContent.vue?vue&type=script&lang=js&"
import style0 from "./SpaceDashboardContent.vue?vue&type=style&index=0&id=6f778d6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f778d6e",
  null
  
)

export default component.exports